import { Outlet } from "react-router-dom";
import { AppSidebar } from "@/components/app-sidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import DynamicBreadcrumb from "@/components/DynamicBreadcrumb";
import NotificationsBell from "@/components/NotificationsBell";

import { useLoading } from "@/hooks/useLoading";
import ModalsPage from "@/components/Modals/modalProvider";
import { Separator } from "@/components/ui/separator";
import { ProgressBarInf } from "./progressbar";

const App = () => {
  const isFetching = useLoading();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center justify-between border-b border-border/50 gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 sticky top-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="flex min-w-0 items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1 text-primary" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4"
            />
            <DynamicBreadcrumb />
          </div>
          <div className="flex shrink-0 items-center px-4">
            <NotificationsBell />
          </div>
          {/* Loading Bar */}
          {isFetching && <ProgressBarInf />}
        </header>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-4 md:pt-0">
          <Outlet />
        </div>
      </SidebarInset>
      <ModalsPage />
    </SidebarProvider>
  );
};

export default App;
